import { render, staticRenderFns } from "./Pep-statement-template-form.vue?vue&type=template&id=a6f94f3a&scoped=true"
import script from "./Pep-statement-template-form.vue?vue&type=script&lang=js"
export * from "./Pep-statement-template-form.vue?vue&type=script&lang=js"
import style0 from "./Pep-statement-template-form.vue?vue&type=style&index=0&id=a6f94f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f94f3a",
  null
  
)

export default component.exports